import axios from 'axios'
import config from 'config'
import { Cookies } from 'utils'


const UserCardGetAPI = () => axios.get(
  `${config.api.APP_API_DOMAIN}/query-cards`,
  {
    headers: {
      Accept        : 'application/json',
      Authorization : `${Cookies.get('token_type')} ${Cookies.get('access_token')}`
    }
  }
);

// FunPoint
const FunPointTokenGetAPI = (data) => axios.post(`${config.api.APP_API_DOMAIN}/funpoint/bind-token`, 
  data,
  {
    headers: {
      Accept: 'application/json',
      Authorization: `${Cookies.get('token_type')} ${Cookies.get('access_token')}`,
    },
  }
);
const FunPointCardAddAPI = (data) => axios.post(
  `${config.api.APP_API_DOMAIN}/funpoint/create-bind-card`,
  data,
  {
    headers: {
      Accept: 'application/json',
      Authorization: `${Cookies.get('token_type')} ${Cookies.get('access_token')}`,
    },
  }
);
const FunPointCardRemoveAPI = (data) => axios.post(
  `${config.api.APP_API_DOMAIN}/funpoint/delete-bind-card`, 
  data,
  {
    headers: {
      Accept: 'application/json',
      Authorization: `${Cookies.get('token_type')} ${Cookies.get('access_token')}`,
    },
  }
);

// TapPay
const TapPayCardAddAPI = (data) => axios.post(
  `${config.api.APP_API_DOMAIN}/tappay/create-bind-card`,
  data,
  {
    headers: {
      Accept: 'application/json',
      Authorization: `${Cookies.get('token_type')} ${Cookies.get('access_token')}`,
    },
  }
);
const TapPayCardRemoveAPI = (data) => axios.post(
  `${config.api.APP_API_DOMAIN}/tappay/delete-bind-card`, 
  data,
  {
    headers: {
      Accept: 'application/json',
      Authorization: `${Cookies.get('token_type')} ${Cookies.get('access_token')}`,
    },
  }
);

export default { 
  UserCardGetAPI,

  FunPointTokenGetAPI,
  FunPointCardAddAPI,
  FunPointCardRemoveAPI,

  TapPayCardAddAPI,
  TapPayCardRemoveAPI,
}
